import { render, staticRenderFns } from "./TheNavbarTopPanelMenuItem.vue?vue&type=template&id=59638c6a&scoped=true&"
import script from "./TheNavbarTopPanelMenuItem.vue?vue&type=script&lang=js&"
export * from "./TheNavbarTopPanelMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./TheNavbarTopPanelMenuItem.vue?vue&type=style&index=0&id=59638c6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59638c6a",
  null
  
)

export default component.exports